document.addEventListener("DOMContentLoaded", function () {
  const viewMapButton = document.getElementById("view-map");

  if (viewMapButton) {
    viewMapButton.addEventListener("click", function () {
      const mapElement = document.getElementById("mainMap");

      if (mapElement) {
        const rect = mapElement.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        const offset = 30;

        window.scrollTo({
          top: rect.top + scrollTop - offset,
          behavior: "smooth",
        });
      }
    });
  }
});
